// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1rFln","title":"Info_title__1E2fC","links":"Info_links__5e9Fm","link":"Info_link__12DkG","logo":"Info_logo__39ahB"};